/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICountryPickerViewProps } from './country-picker';

/**
 * Functional component which renders country picker module.
 * @param props - Configuration for the country picker component.
 * @returns React.FC<ICountryPickerViewProps> - Functional component of the country picker module.
 */
export const countryPickerView: React.FC<ICountryPickerViewProps> = (props: ICountryPickerViewProps) => {
    const { isModalOpen, modalContainer, modalHeaderContainer, modalBodyContainer, heading, modalFooterContainer, subheading, link,
        countryList, stayOnCurrentSiteButton } = props;
    return isModalOpen && countryList ? (
        <Module {...modalContainer} >
            <Node {...modalHeaderContainer}>
                {heading}
                {subheading}
            </Node>
            <Node {...modalBodyContainer}>
                {countryList.map((country) => (
                    <>
                        {country}
                    </>
                ))}
            </Node>
            <Node {...modalFooterContainer}>
                {stayOnCurrentSiteButton}
                {link}
            </Node>
        </Module>
    ) : null;
};

export default countryPickerView;
